
export default function Dateconvert(strdate) { 
    let datesplit2 = strdate.split("/")
    // console.log(datesplit2[0])
    // console.log(datesplit2[1])
    // console.log(datesplit2[2].slice(0, 4))
    let docdatenew = (Number(datesplit2[2].slice(0, 4)) - 543).toString() + (datesplit2[1].length === 2 ? datesplit2[1] : "0" + datesplit2[1]) + (datesplit2[0].length === 2 ? datesplit2[0] : "0" + datesplit2[0]);
    return docdatenew
}